(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };

  // src/js/components/addressFilterForm.js
  var AddressFilterForm = class {
    constructor(_params) {
      this.elements = __spreadValues({}, _params.elements);
      this.redirection = false;
    }
    static create() {
      const addressFilterForm = window.Store.app.theBody.querySelector(".js-address-filter-form");
      const addressFilterField = addressFilterForm.querySelector("#zipcode");
      const submitButton = addressFilterForm.querySelector("button[type=submit]");
      const params = {
        elements: {
          addressFilterForm,
          addressFilterField,
          submitButton
        }
      };
      const obj = new AddressFilterForm(params);
      obj.init();
      return obj;
    }
    init() {
      if (this.elements.addressFilterForm.getAttribute("action") !== "") {
        this.redirection = true;
      }
      this.elements.addressFilterForm.addEventListener("submit", (e) => this.submitHandler(e));
    }
    submitHandler(e) {
      e.preventDefault();
      const storedProperty = e.target.dataset.storedField;
      const fieldValue = e.target.querySelector(`#${storedProperty}`).value;
      if (!fieldValue) {
        sessionStorage.setItem(storedProperty, "");
      } else {
        sessionStorage.setItem(storedProperty, fieldValue);
      }
      if (this.redirection) {
        window.Store.app.barba.go(e.target.getAttribute("action"));
        return;
      } else {
        if (fieldValue !== "") {
        } else {
        }
      }
      this.elements.submitButton.classList.remove("disabled");
      this.elements.submitButton.removeAttribute("disabled");
    }
  };
  function render() {
    window.Store.components.addressFilterForm.obj = AddressFilterForm.create();
  }
  window.Store.components.addressFilterForm.render = render;
})();
